<template>
  <div v-if="mostrar" class="modal-overlay" @click="cancelar">
    <div class="modal-confirmacion" @click.stop>
      <div class="confirm-header">
        <h3>🗑️ ¿Eliminar Pregunta?</h3>
      </div>
      <div class="confirm-body">
        <p><strong>¿Estás seguro de que quieres eliminar esta pregunta?</strong></p>
        <div v-if="pregunta" class="pregunta-preview">
          <strong>Orden {{ pregunta.orden }}:</strong>
          <br>{{ pregunta.pregunta }}
        </div>
        <p class="warning-text">⚠️ Esta acción no se puede deshacer.</p>
      </div>
      <div class="confirm-footer">
        <button @click="cancelar" class="btn btn-secondary">
          Cancelar
        </button>
        <button @click="confirmar" class="btn btn-danger" :disabled="eliminando">
          {{ eliminando ? 'Eliminando...' : 'Eliminar' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalConfirmacion',
  props: {
    mostrar: {
      type: Boolean,
      default: false
    },
    pregunta: {
      type: Object,
      default: null
    },
    eliminando: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirmar() {
      this.$emit('confirmar-eliminacion')
    },
    
    cancelar() {
      this.$emit('cancelar-eliminacion')
    }
  }
}
</script>

<style scoped>
/* 🗑️ Modal de confirmación mejorado */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.4s ease-out;
}

.modal-confirmacion {
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  border-radius: 20px;
  box-shadow: 
    0 25px 50px rgba(41, 70, 151, 0.2),
    0 10px 20px rgba(0,0,0,0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  max-width: 450px;
  width: 90%;
  overflow: hidden;
  animation: scaleIn 0.4s ease-out;
  border: 2px solid rgba(41, 70, 151, 0.15);
  position: relative;
}

.modal-confirmacion::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #1D3C7F, #294697, #007bff);
  border-radius: 20px 20px 0 0;
}

.confirm-header {
  padding: 2rem;
  background: linear-gradient(135deg, #1D3C7F 0%, #294697 50%, #007bff 100%);
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
}

/* 🔧 Efecto shimmer removido - diseño más sobrio */

.confirm-header h3 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.confirm-body {
  padding: 2rem;
  text-align: center;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
}

.confirm-body p {
  font-size: 1.1rem;
  color: #495057;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.pregunta-preview {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 1.5rem;
  border-radius: 12px;
  margin: 1.5rem 0;
  border-left: 4px solid #007bff;
  text-align: left;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border: 1px solid rgba(0, 123, 255, 0.1);
}

.pregunta-preview strong {
  color: #007bff;
  font-weight: 700;
  font-size: 1.1rem;
}

.warning-text {
  color: #1D3C7F;
  font-size: 1rem;
  margin-top: 1.5rem;
  font-weight: 600;
  background: linear-gradient(135deg, #e7f1ff, #cfe2ff);
  padding: 1rem;
  border-radius: 10px;
  border-left: 4px solid #294697;
  box-shadow: 0 2px 8px rgba(41, 70, 151, 0.15);
}

.confirm-footer {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-top: 1px solid rgba(41, 70, 151, 0.15);
}

.btn {
  padding: 0.875rem 2rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* 🔧 Efecto de brillo en botones removido */

.btn-secondary {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #545b62, #3d4043);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4);
}

.btn-danger {
  background: linear-gradient(135deg, #294697, #1D3C7F);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: linear-gradient(135deg, #1f3270, #172753);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(41, 70, 151, 0.4);
}

.btn-danger:disabled {
  background: linear-gradient(135deg, #8aa0e6, #6f86d9);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Responsive mejorado */
@media (max-width: 768px) {
  .modal-confirmacion {
    width: 95%;
    border-radius: 16px;
  }
  
  .confirm-header {
    padding: 1.5rem;
  }
  
  .confirm-header h3 {
    font-size: 1.2rem;
  }
  
  .confirm-body {
    padding: 1.5rem;
  }
  
  .confirm-footer {
    flex-direction: column;
    padding: 1.5rem;
    gap: 0.75rem;
  }
  
  .btn {
    padding: 0.75rem 1.5rem;
  }
}

@media (max-width: 480px) {
  .confirm-body {
    padding: 1rem;
  }
  
  .pregunta-preview {
    padding: 1rem;
  }
}

/* Animaciones mejoradas */
@keyframes fadeIn {
  from { 
    opacity: 0; 
    backdrop-filter: blur(0px);
  }
  to { 
    opacity: 1; 
    backdrop-filter: blur(4px);
  }
}

@keyframes scaleIn {
  from { 
    transform: scale(0.8) translateY(20px); 
    opacity: 0; 
  }
  to { 
    transform: scale(1) translateY(0); 
    opacity: 1; 
  }
}

/* 🔧 Animación shimmer removida */
</style>
